export default {
  check_status: {
    verified: 'Verificado',
    pending: 'Pendiente',
    failed: 'Fallido',
    not_applicable: 'No necesario',
    required: 'Obligatorio',
  },
  records: {
    type: 'Tipo',
    name: 'Nombre',
    value: 'Valor',
    status: 'Estado',
    certificate: 'Certificado',
    certificate_hint: 'Se emite automáticamente cuando se encuentran los registros de arriba.',
    full_name: 'Nombre completo:',
  },
  check_hint: {
    found: 'Se encontró {{values}} en su lugar. Sustitúyelo por el valor indicado.',
    missing: 'No se encontró este registro.',
    certificate: 'No se pudo emitir el certificado. Corrige los registros marcados arriba y vuelve a comprobar.',
    certificate_unknown:
      'No se pudo emitir el certificado. Vuelve a comprobarlo más tarde y contacta con soporte si sigue así.',
    regressed: 'Este registro se había verificado antes y ya no se encuentra.',
    technical: 'Detalle técnico: {{error}}',
    held_by_another_project:
      '{{name}} lo usa otro sitio web en Vercel, así que no puede redirigir a los visitantes a la tienda en www.{{name}}. Para que {{name}} también abra la tienda, primero quita el dominio de ese otro sitio web.',
    certificate_pending: {
      not_attached: 'En curso: estamos añadiendo el dominio por nuestra parte.',
      awaiting_dns: 'En curso: el certificado se emite en cuanto se encuentran los registros de arriba.',
      awaiting_certificate:
        'En curso: los registros apuntan a nosotros y se está emitiendo el certificado. Suele tardar unos minutos.',
    },
    certificate_failed: {
      ownership_proof_required:
        '{{name}} también está conectado a otra cuenta de Vercel. Para demostrar que es tuyo, añade también los registros TXT de abajo en el proveedor de DNS y vuelve a comprobar.',
      held_by_another_project:
        'Otro sitio web en Vercel ya usa {{name}}. Primero quita el dominio de ese sitio web y vuelve a comprobar, o usa otro dominio.',
      dns_correct_but_unconfigured:
        'Los registros de arriba son correctos, pero otra cosa en {{name}} bloquea el certificado. Elimina cualquier registro AAAA en ese nombre, desactiva cualquier proxy que haya delante (como la nube naranja de Cloudflare) y asegúrate de que ningún registro CAA excluya a Let’s Encrypt. Después, vuelve a comprobar.',
      name_mismatch:
        '{{name}} responde con un certificado para {{names}}. Asegúrate de que los registros de arriba son los únicos en {{name}}; si lo son, contacta con soporte.',
      name_mismatch_unnamed:
        '{{name}} responde con un certificado para otro nombre. Asegúrate de que los registros de arriba son los únicos en {{name}}; si lo son, contacta con soporte.',
      expired:
        'El certificado ha caducado y no se ha renovado. Hemos recibido el aviso y nos estamos ocupando; por ahora no tienes que hacer nada.',
      expiring:
        'El certificado caduca pronto y aún no se ha renovado. Nos estamos ocupando; por ahora no tienes que hacer nada.',
      attach_refused:
        'Nuestro proveedor de alojamiento no ha permitido añadir {{name}} por nuestra parte. Nos han avisado y lo estamos revisando; por ahora no hay que cambiar nada en el proveedor de DNS.',
    },
    certificate_overdue: {
      not_attached:
        'Después de 48 horas, todavía no se ha podido añadir el dominio por nuestra parte. Contacta con soporte.',
      awaiting_dns:
        'Después de 48 horas, sigue esperando los registros de arriba. Corrige los registros marcados arriba y vuelve a comprobar.',
      awaiting_dns_records_verified:
        'Sigue sin emitirse después de 48 horas, aunque los registros de arriba están verificados. Contacta con soporte.',
      awaiting_certificate:
        'Los registros apuntan a nosotros, pero el certificado sigue sin emitirse después de 48 horas. Contacta con soporte.',
    },
    certificate_dates: {
      valid_until: 'Válido hasta el {{date}}.',
      expires_on: 'Caduca el {{date}}.',
      expired_on: 'Caducó el {{date}}.',
    },
  },
};
